var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddToListHeartFilledSmall = function SvgAddToListHeartFilledSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.056 3.299C10.108-.573 15.5.645 15.5 5.303a4.77 4.77 0 0 1-.623 2.305l-.498.935.176.166a.5.5 0 0 1 .15.282l.007.082v5.438a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5v-.97l-.263-.215a35.935 35.935 0 0 1-.411-.346l-.413-.358C2.421 9.98.5 7.46.5 5.303.5.645 5.892-.573 7.944 3.3L8 3.41l.056-.111Zm4.153 4.574H7.5v6.137h6.211V9.288l-1.502-1.415Zm-1.603 1.498a.5.5 0 0 1 .5.5l-.001.927h.943a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.5.5h-.943v.928a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.5-.5v-.928h-.942a.5.5 0 0 1-.491-.41l-.009-.09a.5.5 0 0 1 .5-.5h.942v-.927a.5.5 0 0 1 .41-.492l.09-.008Z",
    fill: "#0064FE",
    fillRule: "nonzero"
  }))));
};
export default SvgAddToListHeartFilledSmall;